import {
  ONBOARDING_V1_STEP_IDS,
  OnboardingV1StepSchema,
  type OnboardingV1Step,
} from "@repo/types";

/**
 * The username step is `/start` without a `step` search, where the username
 * dialog opens over the flow's empty frame.
 * The retired `hook` screen stays in the shared contract, so stale links and
 * persisted ids still parse, and resolves to that step.
 */
export type OnboardingV1StepId = Exclude<OnboardingV1Step, "hook">;

export const ONBOARDING_STEP_IDS = ONBOARDING_V1_STEP_IDS.filter(
  (step): step is OnboardingV1StepId => step !== "hook",
);

/** The steps the flow renders; the entry page owns choosing a username. */
export type OnboardingV1FlowStepId = Exclude<OnboardingV1StepId, "name">;

export interface OnboardingV1StepSearch {
  readonly step?: OnboardingV1FlowStepId;
}

export function parseOnboardingV1StepId(
  value: unknown,
): OnboardingV1StepId | null {
  const parsed = OnboardingV1StepSchema.safeParse(value);
  if (!parsed.success) {
    return null;
  }
  return parsed.data === "hook" ? "name" : parsed.data;
}

export function normalizeOnboardingV1StepId(
  value: unknown,
): OnboardingV1StepId {
  return parseOnboardingV1StepId(value) ?? "name";
}

export function normalizeOnboardingV1StepSearch(
  search: Record<string, unknown>,
): OnboardingV1StepSearch {
  const step = normalizeOnboardingV1StepId(search.step);
  return step === "name" ? {} : { step };
}

export function getOnboardingV1StepIndex(step: OnboardingV1StepId): number {
  return ONBOARDING_STEP_IDS.indexOf(step);
}
